import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientRecallsItem } from "./PatientRecallsItem";

class PatientRecallsListItem implements ITableDataSourceItem<PatientRecallsItem> {
    public Model: PatientRecallsItem;
    public Name: string;

    constructor(model: PatientRecallsItem) {
        this.Model = model;
    }
}

export { PatientRecallsListItem };
